"use client";

import { footerBlock } from '@/gql/graphql'
import { PartnerProps } from '@nrldigitaltechnology/ui-community/dist/components/Sponsors/types';
import React from 'react'

type FooterLayoutProps = {
    res: footerBlock | null
    sponsorsCta?: any;
}

type Entity = {
    href: string;
    name: string;
    image?: string;
};

type EntityBlockSection = {
    header: string;
    entities: Entity[];
};

type FooterStateProps = {
    entityBlock: EntityBlockSection[],
    footerLinks: Entity[],
    socialLinks: Entity[],
    sponsorsBlock?: PartnerProps[],
    copyRightText?: string,
    copyRightLogo?: string
}

export const FooterLayoutCompetitions = ({ res, sponsorsCta }: FooterLayoutProps) => {

    return (
        <>
            <div data-an-module="footer" className="bg-black h-[72px] px-4 flex items-center">
                <div className="w-full flex items-center justify-center md:justify-end">
                    <img src={"/assets/logo/logo.svg"} className='w-[40px] h-[40px]' alt="logo" />
                    <p className='text-[12px] text-white ml-4'>© 2025 - National Rugby League</p>
                </div>
            </div>
        </>
    )
}